import TabToggle from 'components/commons/tab-toogle'
import { Checkbox, InlineError, Input } from 'avo-ui'
import UploadImage from 'components/commons/upload-image'

export const GeneralInfo = ({ brandDetail, onChangeForm, errorForm }) => {
    return (
        <TabToggle
            title={'General Info'}
            content={
                <div className={'flex space-x-16'}>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Nama Brand</div>
                            <Input
                                className={'flex-1'}
                                name={'name'}
                                placeholder={'Masukkan nama brand'}
                                value={brandDetail?.name}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.name} />
                        </div>
                        <div
                            className={`flex flex-col ${(brandDetail?.image_url?.base64 || brandDetail?.image_url) && 'space-y-3'}`}
                        >
                            <div className={'font-semibold text-blue-90 required'}>Logo Brand</div>
                            <UploadImage
                                className={'w-fit'}
                                classNameImage={'!w-48 !h-48 border border-neutral-30 rounded-md'}
                                id={'logo-brand'}
                                value={brandDetail?.image_url?.base64 || brandDetail?.image_url}
                                onChange={(value) => onChangeForm({ image_url: value })}
                            />
                            <InlineError className='mt-2' message={errorForm?.image_url} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <Checkbox
                                label={'Highlight Brand Pada Hover Menu Brand'}
                                name={'is_highlight'}
                                checked={!!brandDetail?.is_highlight}
                                value={brandDetail?.is_highlight}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.checked })}
                            />
                            <InlineError className='mt-2' message={errorForm?.is_highlight} />
                        </div>
                    </div>
                    <div className={'flex-1 flex-col space-y-3'}>
                        <div className={'font-semibold text-blue-90 required'}>Deskripsi</div>
                        <Input
                            type={'text-area'}
                            className={'flex-1'}
                            name={'description'}
                            placeholder={'Masukkan deskripsi'}
                            value={brandDetail?.description}
                            row={5}
                            onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                        />
                        <InlineError className='mt-2' message={errorForm?.description} />
                    </div>
                </div>
            }
        />
    )
}
